import axios from 'axios'

const baseURL = process.env.VUE_APP_PREFIX ? `${process.env.VUE_APP_PREFIX}/api` : '/api'

// need plainAxiosRequest to prevent infinite loops in axiosRequest interceptors
export const plainAxiosRequest = axios.create({
  baseURL,
})

const axiosOpts = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
      ? document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      : '',
  },
  baseURL,
}

export const axiosRequest = axios.create(axiosOpts)

export const updateHeaders = token => {
  if (token) {
    axiosRequest.defaults.headers.Authorization = token
    plainAxiosRequest.defaults.headers.Authorization = token
  } else {
    delete axiosRequest.defaults.headers.Authorization
    delete plainAxiosRequest.defaults.headers.Authorization
  }
}

axiosRequest.interceptors.response.use(
  response => response, // Directly return successful responses.
  async error => {
    const originalRequest = error.config
    if (error.response?.status === 401 && !originalRequest._retry) {
      // Mark the request as retried to avoid infinite loops.
      originalRequest._retry = true
      try {
        const response = await plainAxiosRequest.get('/refresh_user')
        const accessToken = response.data.access_token
        // Update the authorization header with the new access token.
        updateHeaders(accessToken)
        originalRequest.headers.Authorization = accessToken
        // Retry the original request with the new access token.
        return axiosRequest(originalRequest)
      } catch (refreshError) {
        updateHeaders()
        window.location.reload()
        return Promise.reject(refreshError)
      }
    }

    // For all other errors, return the error as is.
    return Promise.reject(error)
  }
)
